import { gql } from '@apollo/client'

export default gql`
  mutation BindAccountEmailAndPassword(
    $input: processSetUpEmailAndPasswordInput!
  ) {
    processSetUpEmailAndPassword(input: $input)
  }
`
